const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  windowHeight: state => state.app.height,
  systemType: state => state.app.system,
  adminUrl: state => state.app.adminUrl,
  dcmviwerurl: state => state.app.dcmviwerurl,
  appInfo: state => state.app.appInfo,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  username: state => state.user.username,
  typeName: state => state.user.typeName,
  roleName: state => state.user.roleName,
  code:state => state.user.code,
  userid: state => state.user.userid,
  groupid: state => state.user.groupid,
  doctype: state => state.user.doctype,
  partnershipid: state=> state.user.partnershipid,
  showai: state => state.user.showai,
  canedit: state => state.user.canedit,
  needcloud: state => state.permission.needcloud,
  needSign: state => state.permission.needSign,
  introduction: state => state.user.introduction,
  loading: state => state.permission.loading,
  permission_routes: state => state.permission.routes,
  addRoutes: state => state.permission.addRoutes,
  rights: state => state.permission.rights,
  errorLogs: state => state.errorLog.logs
}
export default getters
